export const validTechs: Array<string> = [
  "reactjs",
  "python",
  "node",
  "angularjs",
  "laravel",
  "django",
  "flutter",
  "dart",
  "php",
  "flask",
  "react-native",
  "kotlin",
  "java",
  "c",
  "go",
  "javascript",
  "swift",
  "ruby",
  "html5",
  "css3",
  "typescript",
];
